import $ from 'jquery';
import RevealWhenVisible from '../../components/reveal-when-visible';
import VideoModalButton from '../../components/video-modal-button';
import SingleProductColorSelect from './components/single-product-color-select';
import SingleProductSlider from '../../components/single-product-slider';
import SingleProductFullscreenSlider from '../../components/single-product-fullscreen-slider';
import StickyBar from '../../components/sticky-bar';
import ScrollTo from '../../components/scroll-to';
import CartPopup from './components/cart-popup';
import SingleProductForm from './components/single-product-form';
import QuantityInput from '../../components/quantity-input';
import RelatedProductsSlider from '../../components/related-products-slider';
import ProductColorSelect from '../../components/product-color-select';
import ProductUsps from './components/product-usps';
import HowProductWorks from './components/how-product-works';
import Timer from '../../components/timer';
import SliderWithPagination from '../../components/slider-with-pagination';
import NewsSlider from '../discover-iqos/components/news-slider';
import ScrollToByUrl from '../../core/components/scroll-to-by-url';
import RatingsAndReviews from './components/ratings-and-reviews';
import CustomizableBundleProducts from './components/customizable-bundle-products';
import ProductTradeIn from './components/product-trade-in';
import BubblesSlider from '../../components/bubbles-slider';
import BlocksSlider from './components/blocks-slider';
import Collapse from '../../components/collapse';
import DropdownSelect from '../../components/dropdown-select';
import InlineVideo from '../../components/inline-video';
import ResponsiveVideo from '../../components/responsive-video';
import RelatedAccessoriesSlider from '../../components/related-accessories-slider';
import VariantStockForm from './components/variant-stock-form';
$(() => {
    VideoModalButton.init();
    RatingsAndReviews.init();
    VariantStockForm.init();
    SingleProductForm.init();
    SingleProductSlider.init();
    SingleProductFullscreenSlider.init();
    SingleProductColorSelect.init();
    CustomizableBundleProducts.init();
    ProductTradeIn.init();
    QuantityInput.init();
    CartPopup.init();
    RevealWhenVisible.init();
    RelatedProductsSlider.init();
    RelatedAccessoriesSlider.init();
    ProductColorSelect.init();
    ProductUsps.init();
    HowProductWorks.init();
    Timer.init();
    ScrollTo.init();
    StickyBar.init();
    SliderWithPagination.init();
    NewsSlider.init();
    BlocksSlider.init();
    BubblesSlider.init();
    Collapse.init();
    DropdownSelect.init();
    InlineVideo.init();
    ResponsiveVideo.init();
    setTimeout(() => {
        ScrollToByUrl.init();
    }, 0);
});
